<script lang="ts">
	import type { Snippet } from 'svelte';
	import { getTabsContext } from './tabs.context.svelte';

	interface Props {
		id: string;
		children: Snippet;
	}
	let { id, children }: Props = $props();

	const ctx = getTabsContext();
</script>

{#if ctx.activeTab === id}
	{@render children()}
{/if}
